import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface UsageStatisticsEventInput {
  userType: SystemCode
  counter: number
}

export function UsageStatisticsEventInputFromJSON(
  json: any
): UsageStatisticsEventInput {
  return {
    userType: exists(json, 'user_type')
      ? SystemCodeFromJSON(json.user_type)
      : defaultSystemCode(),
    counter: exists(json, 'counter') ? json.counter : 0
  }
}
